import { stepConfigItem } from './types';

const stepsSchema: stepConfigItem[] = [
  {
    id: 'preferredMacronutrientRatio',
    slug: 'diet-type',
  },
  { id: 'summary', slug: 'summary' },
];

export default stepsSchema;
